import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMessageCircle } = FiIcons;

const FloatingWhatsApp = () => {
  const handleWhatsAppClick = () => {
    window.open('https://wa.me/923477722225', '_blank');
  };

  return (
    <motion.button
      className="fixed bottom-6 right-4 md:right-6 bg-green-500 text-white p-4 rounded-full shadow-lg hover:bg-green-600 transition-colors duration-200 z-[9999]"
      style={{ 
        position: 'fixed', 
        bottom: '24px', 
        right: window.innerWidth <= 768 ? '50px' : '40px',
        zIndex: 9999 
      }}
      onClick={handleWhatsAppClick}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.9 }}
      initial={{ opacity: 0, y: 100 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 1, duration: 0.5 }}
    >
      <SafeIcon icon={FiMessageCircle} className="h-6 w-6" />
    </motion.button>
  );
};

export default FloatingWhatsApp;